import { PdfIndex } from './PdfIndex';
import { LadderLogic } from './pages/LadderLogic';
import { Workflows } from './pages/Workflows';
import { Dashboards } from './pages/Dashboards';
import { NetworkScanner } from './pages/NetworkScanner';
import { SmartAssist } from './pages/SmartAssist';
import { Reporting } from './pages/Reporting';
import { AlarmPipelines } from './pages/AlarmPipelines';
import { DataInfrastructure } from './pages/DataInfrastructure';
import { Historian } from './pages/Historian';
import { JsScripting } from './pages/JsScripting';
import { CustomPages } from './pages/CustomPages';
import { Appliance } from './pages/Appliance';
import { PlatformOverview } from './pages/PlatformOverview';
import { PremadeSetups } from './pages/PremadeSetups';
import { ApiAccess } from './pages/ApiAccess';
import { MachineVision } from './pages/MachineVision';

const pages: Record<string, { component: React.FC; label: string }> = {
  'platform-overview': { component: PlatformOverview, label: 'Platform Overview' },
  'appliance': { component: Appliance, label: 'The Appliance' },
  'ladder-logic': { component: LadderLogic, label: 'Ladder Logic' },
  'workflows': { component: Workflows, label: 'Workflows' },
  'dashboards': { component: Dashboards, label: 'Dashboards' },
  'network-scanner': { component: NetworkScanner, label: 'Network Scanner' },
  'smart-assist': { component: SmartAssist, label: 'Smart Assist' },
  'reporting': { component: Reporting, label: 'Reporting' },
  'alarm-pipelines': { component: AlarmPipelines, label: 'Alarm Pipelines' },
  'data-infrastructure': { component: DataInfrastructure, label: 'Data Infrastructure' },
  'historian': { component: Historian, label: 'Historian' },
  'js-scripting': { component: JsScripting, label: 'JavaScript Scripting' },
  'custom-pages': { component: CustomPages, label: 'Custom Pages' },
  'premade-setups': { component: PremadeSetups, label: 'Premade Setups' },
  'machine-vision': { component: MachineVision, label: 'Machine Vision' },
  'api-access': { component: ApiAccess, label: 'REST API' },
};

export const pdfSlugs = Object.entries(pages).map(([slug, { label }]) => ({ slug, label }));

export function PdfRouter({ slug }: { slug: string }) {
  if (slug === 'index') {
    return <PdfIndex />;
  }

  const entry = pages[slug];
  if (!entry) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ink-base">
        <p className="text-text-secondary">
          Unknown PDF: <code className="text-brand-primary">{slug}</code>.{' '}
          <a href="#pdf/index" className="text-brand-primary underline">
            View all PDFs
          </a>
        </p>
      </div>
    );
  }

  const Page = entry.component;
  return <Page />;
}
